(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (disclosure && typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initBumpHeaderMegaMenus(root = document) {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const menus = Array.from(root.querySelectorAll('[data-bump-desktop-menu]'));
    if (!menus.length) return;

    menus.forEach((menu) => {
      if (menu.dataset.bumpMegaBound === 'true') return;
      menu.dataset.bumpMegaBound = 'true';

      const shell = menu.querySelector('[data-bump-mega-shell]');
      const triggers = Array.from(menu.querySelectorAll('[data-bump-menu-trigger]'));
      const panels = Array.from(menu.querySelectorAll('[data-bump-menu-panel]'));
      if (!shell || !triggers.length || !panels.length) return;

      const panelByKey = new Map();
      panels.forEach((panel) => {
        panelByKey.set(panel.getAttribute('data-bump-menu-panel'), panel);
      });

      let activeKey = null;
      let closeTimer = null;

      const clearCloseTimer = () => {
        if (!closeTimer) return;
        window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const syncTriggerState = (key) => {
        triggers.forEach((trigger) => {
          const triggerKey = trigger.getAttribute('data-bump-menu-trigger');
          const isActive = key && triggerKey === key;
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          const navItem = trigger.closest('[data-bump-nav-item]');
          if (navItem) navItem.classList.toggle('is-active', !!isActive);
        });
      };

      const closePanels = () => {
        clearCloseTimer();
        activeKey = null;
        shell.classList.remove('is-open');
        shell.setAttribute('aria-hidden', 'true');
        panels.forEach((panel) => panel.classList.remove('is-active'));
        syncTriggerState(null);
      };

      const openPanel = (key) => {
        if (!desktopQuery.matches || !key) return;
        const panel = panelByKey.get(key);
        if (!panel) return;
        if (activeKey === key && shell.classList.contains('is-open')) {
          clearCloseTimer();
          return;
        }

        activeKey = key;
        clearCloseTimer();
        shell.classList.add('is-open');
        shell.setAttribute('aria-hidden', 'false');
        panels.forEach((item) => item.classList.toggle('is-active', item === panel));
        syncTriggerState(key);
      };

      const scheduleClose = () => {
        clearCloseTimer();
        closeTimer = window.setTimeout(closePanels, 140);
      };

      triggers.forEach((trigger) => {
        const key = trigger.getAttribute('data-bump-menu-trigger');
        trigger.addEventListener('mouseenter', () => openPanel(key));
        trigger.addEventListener('focus', () => openPanel(key));
      });

      menu.addEventListener('mouseenter', clearCloseTimer);
      menu.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('focusout', (event) => {
        if (menu.contains(event.relatedTarget)) return;
        scheduleClose();
      });
      shell.addEventListener('mouseenter', clearCloseTimer);
      shell.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closePanels();
      });

      document.addEventListener('click', (event) => {
        if (menu.contains(event.target)) return;
        closePanels();
      });

      const onMediaChange = (event) => {
        if (event.matches) return;
        closePanels();
      };
      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onMediaChange);
      } else {
        desktopQuery.addListener(onMediaChange);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBumpHeaderMegaMenus(document), { once: true });
  } else {
    initBumpHeaderMegaMenus(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBumpHeaderMegaMenus(event.target || document);
  });


  } catch(e) { console.error(e); }
})();
})();
